import {useEffect} from 'react';
import {createFileRoute, redirect, useNavigate} from '@tanstack/react-router';

import {useAuthStore} from '@/store/auth';
import {useAuth} from '@/hooks/useAuth';
import {ResetPasswordPage} from '@/modules/auth/pages/ResetPasswordPage';

interface ResetPasswordSearch {
  token: string;
}

const validateResetPasswordSearch = (search: Record<string, unknown>): ResetPasswordSearch => ({
  token: typeof search.token === 'string' ? search.token : '',
});

export const Route = createFileRoute('/reset-password')({
  validateSearch: validateResetPasswordSearch,
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({to: '/'});
    }
  },
  component: ResetPasswordGuard,
});

function ResetPasswordGuard() {
  const {isAuthenticated, isLoading} = useAuth();
  const {token} = Route.useSearch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // replace: true — /reset-password is not a place an authenticated
      // user should be able to back-button to. Matches login.tsx.
      void navigate({to: '/', replace: true});
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (!isLoading && isAuthenticated) {
    return null;
  }

  return <ResetPasswordPage token={token} />;
}
